import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

const MOCK_USER_RSP = {
  firstname: 'John',
  lastname: 'Smith',
  role: 'user' as const,
};

export interface UserState {
  authenticated: boolean;
  value: {
    firstname: string;
    lastname: string;
    role: 'user' | 'admin';
  } | null;
  status: 'idle' | 'loading' | 'success' | 'failure';
  error: string;
  sfvAttempted: boolean;
  hasProfileAccess: boolean | undefined;
  hasCspProfile: boolean | undefined;
}

const initialState: UserState = {
  authenticated: false,
  value: null,
  status: 'idle',
  error: '',
  sfvAttempted: false,
  hasProfileAccess: undefined,
  hasCspProfile: undefined,
};

export const logonThunk = createAsyncThunk('user/logon', () => {
  return MOCK_USER_RSP;
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logOff: () => ({ ...initialState }),
    logOn: (state) => {
      state.authenticated = true;
    },
    toggleSfvAttempt: (state, action: PayloadAction<boolean>) => {
      state.sfvAttempted = action.payload;
    },
    setHasProfile: (state, action) => {
      state.hasProfileAccess = action.payload;
    },
    setHasCspProfile: (state, action) => {
      state.hasCspProfile = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logonThunk.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(logonThunk.fulfilled, (state, action) => {
        state.value = action.payload;
        state.error = '';
        state.status = 'success';
      })
      .addCase(logonThunk.rejected, (state, action) => {
        state.value = null;
        state.error = JSON.stringify(action.error.message);
        console.error(JSON.stringify(action.error));
        state.status = 'failure';
      });
  },
});

export const {
  logOff,
  logOn,
  toggleSfvAttempt,
  setHasProfile,
  setHasCspProfile,
} = authSlice.actions;

export default authSlice.reducer;
